'use client';

import Highlight1 from '../../../../public/images/careers/highlights1.svg';
import Highlight2 from '../../../../public/images/careers/highlights2.svg';
import Highlight3 from '../../../../public/images/careers/highlights3.svg';
import Highlight4 from '../../../../public/images/careers/highlights4.svg';
import ScrollWithCarets from 'src/components/ScrollWithCarets';

type Props = {};

export default function HighlightsSection(props: Props) {
    return (
        <section className="my-4 md:my-10">
            <div className="container mx-auto mb-4 px-4 text-center md:mb-8">
                <h2 className="text-4xl md:text-6xl xl:text-7xl">Valorile noastre</h2>
            </div>
            <ScrollWithCarets>
                <div className="container relative mx-auto h-72 overflow-visible md:h-auto md:px-4">
                    <div className="absolute flex h-full flex-nowrap md:static md:grid md:grid-cols-2 md:gap-8">
                        <div
                            data-carousel-item
                            className="bg-light-green relative w-80 snap-start p-8 py-4 md:w-auto md:p-12">
                            <Highlight1 className="h-8 md:h-12" />
                            <h3 className="text-primary my-4 text-2xl md:text-4xl">Performanță</h3>
                            <p className="text-sm md:text-base">
                                În fiecare zi, ne dorim să fim mai buni decât am fost ieri. Suntem conștienți că
                                performanța implică determinare și suntem determinați să facem tot ce este posibil
                                pentru a ne ajuta pacienții și a le oferi serviciile pe care le merită.
                            </p>
                        </div>

                        <div
                            data-carousel-item
                            className="bg-light-grey relative w-80 snap-center p-8 py-4 md:w-auto md:p-12">
                            <Highlight2 className="h-8 md:h-12" />
                            <h3 className="text-primary my-4 text-2xl md:text-4xl">Curaj</h3>
                            <p className="text-sm md:text-base">
                                Curajul este calitatea care ne ajută să ne îndeplinim obiectivele. Ne asumăm cu
                                responsabilitate tot ceea ce facem, învățăm și creștem. Pentru că doar prin ambiție și
                                perseverență putem să devenim din ce în ce mai buni.
                            </p>
                        </div>

                        <div
                            data-carousel-item
                            className="bg-light-green md:bg-light-grey relative w-80 snap-center p-8 py-4 md:w-auto md:p-12">
                            <Highlight3 className="h-8 md:h-12" />
                            <h3 className="text-primary my-4 text-2xl md:text-4xl">Ajutorare</h3>
                            <p className="text-sm md:text-base">
                                Pe primul loc punem oamenii și ceea ce ne diferențiază este dorința de a face bine la
                                nivel de comunitate. Investim în tehnologie și în aparatură modernă, dar punem prețul
                                cel mai mare pe empatie și umanitate.
                            </p>
                        </div>

                        <div
                            data-carousel-item
                            className="bg-lightest-grey relative w-80 snap-end p-8 py-4 md:w-auto md:p-12">
                            <Highlight4 className="h-8 md:h-12" />
                            <h3 className="text-primary my-4 text-2xl md:text-4xl">Implicare</h3>
                            <p className="text-sm md:text-base">
                                Ne pasă și ne implicăm cu dedicare chiar dacă uneori întâmpinăm situații dificile. Este
                                în puterea noastră să facem lucrurile să se întâmple, însă doar atunci când punem suflet
                                putem ajunge acolo unde ne dorim.
                            </p>
                        </div>
                    </div>
                </div>
            </ScrollWithCarets>
        </section>
    );
}
